module.exports = __webpack_public_path__ + "img/birth-cert.04f2c3af.png";